import { FILINGS_URL_PREFIX, FILINGS_URL_PREFIX_INTERACTIVE } from './constants/constants'
import { ParsedLatestFilingsData, SerializedLatestFilingsData } from './constants/types'

export function parseSerializedLatestFilingsData(data: SerializedLatestFilingsData): ParsedLatestFilingsData {
  return {
    ...data,
    items: data.items.map((x) => ({
      ...x,
      filingDate: x.filingDate ? new Date(x.filingDate) : undefined,
      reportDate: x.reportDate ? new Date(x.reportDate) : undefined,
      document: x.primaryDocumentUrl
        ? `${x.interactive ? FILINGS_URL_PREFIX_INTERACTIVE : FILINGS_URL_PREFIX}${x.primaryDocumentUrl}`
        : undefined,
      filing: x.filingRootUrl ? `${FILINGS_URL_PREFIX}${x.filingRootUrl}` : undefined,
      description: x.form ? data.descriptions[x.form] : undefined,
    })),
  }
}
